'use client';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface HeaderMenuProps {
  children: ReactNode;
  className?: string;
  mobileMenuOpen?: boolean;
  onMobileMenuToggle?: () => void;
}

const HeaderMenu = ({ 
  children, 
  className,
  mobileMenuOpen,
  onMobileMenuToggle 
}: HeaderMenuProps) => {
  return (
    <nav data-component-id="src/components/ui/HeaderMenu.tsx:19:4" data-component-path="src/components/ui/HeaderMenu.tsx" data-component-line="19" data-component-end-line="21" data-component-file="HeaderMenu.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%7D" className={twMerge('hidden lg:flex lg:items-center lg:gap-8', className)}>
      {children}
    </nav>
  );
};

export default HeaderMenu;